/**
 * Resource name used to request a presigned url of a file upload from a topic.
 * @type {string}
 */
export const GROUP_MESSAGE_FILE_UPLOAD = 'GROUP_MESSAGE_FILE_UPLOAD';
export const GROUP_MESSAGE_FILE_DOWNLOAD = 'GROUP_MESSAGE_FILE_DOWNLOAD';

export const USER_PROFILE_PHOTO_UPLOAD = 'USER_PROFILE_PHOTO_UPLOAD';
export const USER_PROFILE_PHOTO_DOWNLOAD = 'USER_PROFILE_PHOTO_DOWNLOAD';

export const EVENT_FILE_UPLOADS = 'EVENT_FILE_UPLOADS';
export const EVENT_FILE_SINGLE_DOWNLOAD = 'EVENT_FILE_SINGLE_DOWNLOAD';

export const CASE_AVATAR_FILE_UPLOAD = 'CASE_AVATAR_FILE_UPLOAD';
export const CASE_AVATAR_FILE_SINGLE_DOWNLOAD = 'CASE_AVATAR_FILE_SINGLE_DOWNLOAD';

export const CONSULT_REQUEST_FILE_UPLOADS = 'CONSULT_REQUEST_FILE_UPLOADS';
export const CONSULT_REQUEST_FILE_SINGLE_DOWNLOAD = 'CONSULT_REQUEST_FILE_SINGLE_DOWNLOAD';

export const OCC_HEALTH_PDF_UPLOADS = 'OCC_HEALTH_PDF_UPLOADS';
export const OCC_HEALTH_PDF_DOWNLOAD = 'OCC_HEALTH_PDF_DOWNLOAD';
export const OCC_HEALTH_PDF_DELETE = 'OCC_HEALTH_PDF_DELETE';

export const EMPLOYER_LOGO_UPLOAD = 'EMPLOYER_LOGO_UPLOAD';
